/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { repeatMobileOrderItemGroupUnionModifierSchema } from "./repeatMobileOrderItemGroupUnionModifierSchema.ts";
import { repeatMobileOrderItemModifierSchema } from "./repeatMobileOrderItemModifierSchema.ts";

export const repeatMobileOrderItemSchema = z.object({
	id: z.uuid().nullish(),
	amount: z.int(),
	size: z.uuid().nullish(),
	price: z.number().nullish(),
	internal_reason: z.string().nullish(),
	comment: z.string().nullish(),
	modifiers: z.array(repeatMobileOrderItemModifierSchema).nullish(),
	group_modifiers: z.array(repeatMobileOrderItemGroupUnionModifierSchema).nullish(),
	available: z.boolean(),
	reason: z.string().nullish(),
});
